import { defineComponent as _defineComponent } from 'vue'
import IconLink from './IconLink.vue';
import UserFolders from '~/components/hub/UserFolders.vue';
import UserProfile from '~/components/hub/UserProfile.vue';
import UserTimeSaved from '~/components/hub/UserTimeSaved.vue';
import { resources, extras } from '~/data/navigation_links_hub_left';

export default /*#__PURE__*/_defineComponent({
  __name: 'LargeNavLeft',
  setup(__props) {


return { __sfc: true,IconLink, UserFolders, UserProfile, UserTimeSaved, resources, extras }
}

})